module.exports = __webpack_public_path__ + "img/icon_sm_wlzhsq.f1ee435d.png";